import { PaginationParams } from '@/app/common/hooks/usePagination'
import { parseRequestError } from '@/app/common/utilities'
import axiosInstance from '@/libs/axios_config'
import {
  TransactionDetails,
  TransactionDetailsSchema,
} from './transaction_detail.schema'

export const getTransactionDetails = async (
  program_id: number,
  transaction_id?: number
): Promise<TransactionDetails> => {
  try {
    if (transaction_id == null) {
      return Promise.reject(new Error('Invalid request'))
    }
    const response = await axiosInstance.get(
      `/scholar/transactions/${transaction_id}`,
      { params: { program_id } }
    )
    return TransactionDetailsSchema.parse(response.data)
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}

export type TransactionQuery = {
  applicant_id: number
  program_id: number
  student_id?: string | number
} & PaginationParams

export const getApplicantTransactions = (query: TransactionQuery) => {
  const params = {
    applicant_id: query.applicant_id,
    program_id: query.program_id,
    paginate: query.paginate,
    per_page: query.per_page,
    page: query.page,
    ...(query.student_id != null && { student_id: query.student_id }),
    ...(query.search && { search: query.search }),
    ...(query.sort_by && { sort_by: query.sort_by }),
    ...(query.sort_order && { sort_order: query.sort_order }),
  }

  return axiosInstance.get('/scholar/applicant_transactions', {
    params,
  })
}
